<script setup></script>

<template>
    <div class="layout-footer"></div>
</template>
